import {getServiceDataWithHeaders, convertDate} from './Util';

const ApiService = {

    apiWsUrl : 'https://financialmodelingprep.com/api/v3/',
    apiWsUrlv4: 'https://financialmodelingprep.com/api/v4/',
    apiKey : 'apikey=743e91b075adaf061095059d4673678c',
    
    async getSectorPerformance(){
        let url = this.apiWsUrl + 'sectors-performance?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getGainers(){
        let url = this.apiWsUrl + 'gainers?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getLoosers(){
        let url = this.apiWsUrl + 'losers?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getActives(){
        let url = this.apiWsUrl + 'actives?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    }, 

    async getAllStockNews(limit){
        let url = this.apiWsUrl + 'stock_news?limit=' + limit + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getStockNews(limit,tickers){
        let url = this.apiWsUrl + 'stock_news?tickers=' + encodeURI(tickers) + '&limit=' + limit + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },    
    
    async getEarningCalender(days=10){
        let today = new Date();
        // let todayDate = today.toISOString().split('T')[0]
        let startDate = convertDate(today);

        let tmpEndDate = today;
        tmpEndDate.setDate(today.getDate()+days); //default - Get it for next 10 days
        let endDate = convertDate(tmpEndDate);

        let url = this.apiWsUrl + 'earning_calendar?from=' + startDate + '&to=' + endDate + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },
    
    async getIPOCalender(days=10){
        let today = new Date();
        // let todayDate = today.toISOString().split('T')[0]
        let startDate = convertDate(today);

        let tmpEndDate = today;
        tmpEndDate.setDate(today.getDate()+days); //default - Get it for next 10 days
        let endDate = convertDate(tmpEndDate);

        let url = this.apiWsUrl + 'ipo_calendar?from=' + startDate + '&to=' + endDate + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },
    
    async getEconomicCalender(days=10){
        let today = new Date();
        let startDate = convertDate(today);

        let tmpEndDate = today;
        tmpEndDate.setDate(today.getDate()+days); //default - Get it for next 10 days
        let endDate = convertDate(tmpEndDate);

        let url = this.apiWsUrl + 'economic_calendar?from=' + startDate + '&to=' + endDate + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getStockDividendCalender(days=10){
        let today = new Date();
        let startDate = convertDate(today);

        let tmpEndDate = today;
        tmpEndDate.setDate(today.getDate()+days); //default - Get it for next 10 days
        let endDate = convertDate(tmpEndDate);

        let url = this.apiWsUrl + 'stock_dividend_calendar?from=' + startDate + '&to=' + endDate + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getStockSplitCalender(days=10){
        let today = new Date();
        let startDate = convertDate(today);

        let tmpEndDate = today;
        tmpEndDate.setDate(today.getDate()+days); //Get it for next 10 days
        let endDate = convertDate(tmpEndDate);

        let url = this.apiWsUrl + 'stock_split_calendar?from=' + startDate + '&to=' + endDate + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getStockHistoricalPrice(ticker, interval){
        let url = this.apiWsUrl + 'historical-chart/' + interval + '/' + encodeURI(ticker) + '?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },
    
    async getCommodity(){
        let url = this.apiWsUrl + 'quotes/commodity?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },   
    
    async getIndex(){
        let url = this.apiWsUrl + 'quotes/index?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },     

    async getQuotes(tickers){
        let url = this.apiWsUrl + 'quote/' +  encodeURI(tickers) + '?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getHistoricalQuotesFull(tickers){
        let toDate = new Date().toISOString().slice(0, 10);
        const toYearFromNow = new Date();
        toYearFromNow.setFullYear(toYearFromNow.getFullYear() - 6);
        let fromDate = toYearFromNow.toISOString().slice(0, 10);

        let url = this.apiWsUrl + 'historical-price-full/' +  encodeURI(tickers) 
        + '?from=' + fromDate + '&to=' + toDate
        + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },
    
    async getCompanyOutlook(tickers){
        let url = this.apiWsUrlv4 + 'company-outlook?symbol=' +  encodeURI(tickers) + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },
    
    async getInstitutionalHolder(tickers){
        let url = this.apiWsUrl + 'institutional-holder/' +  encodeURI(tickers) + '?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    }, 

    async getSharesFloat(tickers){
        let url = this.apiWsUrlv4 + 'shares_float?symbol=' +  encodeURI(tickers) + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    }, 

    async getGrade(tickers, limit=200){
        let url = this.apiWsUrl + 'grade/' +  encodeURI(tickers) + '?limit=' + limit + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    }, 

    async getInsiderTrading(tickers, limit=1000){
        let url;
        if (tickers !== null && tickers !== undefined && tickers !== '') {
            url = this.apiWsUrlv4 + 'insider-trading?symbol=' +  encodeURI(tickers) + '&limit=' + limit + '&' + this.apiKey;
        } else {
            url = this.apiWsUrlv4 + 'insider-trading?&limit=' + limit + '&' + this.apiKey;
        }
        return getServiceDataWithHeaders(url);
    }, 

    async getFmpArticles(limit=100){
        let url = this.apiWsUrlv4 + 'articles?page=0&size=' + limit + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    }, 

    async getPressReleases(tickers, limit=100){
        let url = this.apiWsUrl + 'press-releases/' + encodeURI(tickers) +  '?page=0&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },    

    async getStockScreener(crit, limit=100){
        let url = this.apiWsUrl + 'stock-screener?limit=' + limit + '&' + this.apiKey;

        if (crit !== undefined){
            for (var i=0; i<crit.length; i++){
                url = url + '&' + encodeURI(crit[i].criteria) + '=' + encodeURI(crit[i].value);
            }
        }

        return getServiceDataWithHeaders(url);
    }, 

    async getCompanyRatings(ticker){
        let url = this.apiWsUrl + 'rating/' +  encodeURI(ticker) + '?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getAvailableCryptoCurrencies(){
        let url = this.apiWsUrl + 'symbol/available-cryptocurrencies?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getAllQuotesCrypto(){
        let url = this.apiWsUrl + 'quotes/crypto?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getAllQuotesForex(){
        let url = this.apiWsUrl + 'quotes/forex?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },    

    async getAllQuotesCommodity(){
        let url = this.apiWsUrl + 'quotes/commodity?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },    

    async getAllQuotesEtf(){
        let url = this.apiWsUrl + 'quotes/etf?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },     

    async getAllQuotesMutualFund(){
        let url = this.apiWsUrl + 'quotes/mutual_fund?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },      

    async getEarningSurprises(ticker){
        let url = this.apiWsUrl + 'earnings-surprises/' +  encodeURI(ticker) + '?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getStockDividend(ticker){
        let url = this.apiWsUrl + 'historical-price-full/stock_dividend/' +  encodeURI(ticker) + '?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },   

    async getStockPeers(ticker){
        let url = this.apiWsUrlv4 + 'stock_peers?symbol=' +  encodeURI(ticker) + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },      

    async getPrePostStock(ticker, interval, startDate, endDate){
        let today = new Date();
        endDate = convertDate(today);
        // startDate = convertDate(today);

        let tmpEndDate = today;
        let days = 3; 
        tmpEndDate.setDate(today.getDate()-days); //Get it for last 4 days
        startDate = convertDate(tmpEndDate);
        console.log('startDate', startDate, 'endDate', endDate);

        let minOrHour = '', minOrHourValue = 1;
        if (interval.endsWith('min')){
            minOrHourValue = interval.replace('min', '');
            minOrHour = 'minute';
        } if (interval.endsWith('hour')){
            minOrHourValue = interval.replace('hour', '');
            minOrHour = 'hour'
        }

        let url = this.apiWsUrlv4 + 'historical-price/'+ encodeURI(ticker)  + '/' + minOrHourValue + '/'+ minOrHour 
            + '/' + startDate + '/' + endDate
            + '?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },      
    
    async getPrePostStockToday(ticker, interval){
        let today = new Date();
        let endDate = convertDate(today);
        let startDate = convertDate(today);

        // let tmpEndDate = today;
        // let days = 1;
        // tmpEndDate.setDate(today.getDate()-days); //Get it for last 4 days
        // startDate = convertDate(tmpEndDate);

        let minOrHour = '', minOrHourValue = 1;
        if (interval.endsWith('min')){
            minOrHourValue = interval.replace('min', '');
            minOrHour = 'minute';
        } if (interval.endsWith('hour')){
            minOrHourValue = interval.replace('hour', '');
            minOrHour = 'hour'
        }

        let url = this.apiWsUrlv4 + 'historical-price/'+ encodeURI(ticker)  + '/' + minOrHourValue + '/'+ minOrHour 
            + '/' + startDate + '/' + endDate
            + '?' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },

    async getPriceTarget(ticker){
        let url = this.apiWsUrlv4 + 'price-target?symbol=' +  encodeURI(ticker) + '&' + this.apiKey;
        return getServiceDataWithHeaders(url);
    },      

    async getUpgradeDowngrade(ticker){
        let url;
        if (ticker !== null && ticker !== undefined && ticker !== '') {
            url = this.apiWsUrlv4 + 'upgrades-downgrades?symbol=' +  encodeURI(ticker) + '&' + this.apiKey;
        } else {
            url = this.apiWsUrlv4 + 'upgrades-downgrades-rss-feed?page=0' + '&' + this.apiKey;
        }
        return getServiceDataWithHeaders(url);
    },    
    
    async getSenateTrading(ticker){
        let url;
        if (ticker !== null && ticker !== undefined && ticker !== '') {
            url = this.apiWsUrlv4 + 'senate-trading?symbol=' +  encodeURI(ticker) + '&' + this.apiKey;
        } else {
            url = this.apiWsUrlv4 + 'senate-trading-rss-feed?page=0' + '&' + this.apiKey;
        }
        return getServiceDataWithHeaders(url);
    },      
}

export default ApiService ;